import chunk from 'lodash/chunk';

const chunkfyTask = async (array, task, pageSize = 100) => {
  const requestPromises = chunk(array, pageSize)
    .map(async (c) => task(c));

  const result = (await Promise.all(requestPromises))
    .flatMap((chunkData) => chunkData);

  return result;
};

export default chunkfyTask;
